<template>
  <el-dialog
    class="dialog"
    title="问卷预览"
    fullscreen
    :visible.sync="showPreviewModal.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="closeDialog"
  >
    <div>
      <div class="exam-title">{{ examPaperInfo.questionnaireName }}</div>
    </div>
    <div class="paper">
      <template>
        <!-- <div class="exam-category">
          单选题
        </div> -->
        <questionnair :datas="examPaperInfo.qstList"></questionnair>
      </template>
      <!-- <template v-if="examPaperInfo.multipleQstCount > 0">
        <div class="exam-category">
          多选题
        </div>
        <questionnair
          :questionType="1"
          :datas="examPaperInfo.multipleQstList"
        ></questionnair>
      </template>
      <template v-if="examPaperInfo.judgeQstCount > 0">
        <div class="exam-category">
          判断题
        </div>
        <questionnair
          :questionType="2"
          :datas="examPaperInfo.judgeQstList"
        ></questionnair>
      </template>
      <template v-if="examPaperInfo.blanksQstCount > 0">
        <div class="exam-category">
          填空题
        </div>
        <questionnair
          :questionType="3"
          :datas="examPaperInfo.blanksQstList"
        ></questionnair>
      </template>
      <template v-if="examPaperInfo.answersQstCount > 0">
        <div class="exam-category">
          问答题
        </div>
        <questionnair
          :questionType="4"
          :datas="examPaperInfo.answersQstList"
        ></questionnair>
      </template> -->
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialog" size="small"
        >关闭</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { previewQuestionnaire } from "@/api/questionnaire";
import Questionnair from "@/views/questionnaireQuestion";
export default {
  components: {
    Questionnair,
  },
  props: {
    showPreviewModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
          uuid: "",
        };
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      examPaperInfo: {},
    };
  },
  created() {
    previewQuestionnaire(this.showPreviewModal.uuid).then((res) => {
      if (!res || res.code != 0) return;
      this.examPaperInfo = res.data;
    });
  },
  watch: {
    examPaperInfo() {
      this.$nextTick(() => {
        let doms = document.getElementsByClassName("exam-category");
        for (let index = 0; index < doms.length; index++) {
          const element = doms[index];
          element.innerText =
            this.mapNum2Chinese(index + 1) + "、" + element.innerText;
        }
      });
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    mapNum2Chinese(num) {
      switch (num) {
        case 1:
          return "一";
        case 2:
          return "二";
        case 3:
          return "三";
        case 4:
          return "四";
        case 5:
          return "五";
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #343c4a;
.dialog {
  /deep/ .el-dialog.is-fullscreen {
    overflow: hidden;
  }
  /deep/ .el-dialog__body {
    max-height: calc(100% - 117px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 10px 40px;
  }
  .exam-title {
    font-size: 20px;
    color: $color;
    text-align: center;
  }
  .exam-score {
    font-size: 14px;
    color: $color;
    text-align: center;
    margin: 10px 0;
  }
  .exam-category {
    font-size: 15px;
    font-weight: 500;
    color: $color;
  }
  .dialog-footer {
    text-align: center;
  }
  .paper {
    flex: 1;
    overflow: auto;
    .exam-category {
      font-size: 15px;
      font-weight: 500;
      color: $color;
    }
  }
}
</style>
